import { render, staticRenderFns } from "./ok_cancel_dialog.vue?vue&type=template&id=1f370a27&scoped=true"
import script from "./ok_cancel_dialog.vue?vue&type=script&lang=js"
export * from "./ok_cancel_dialog.vue?vue&type=script&lang=js"
import style0 from "./ok_cancel_dialog.vue?vue&type=style&index=0&id=1f370a27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f370a27",
  null
  
)

export default component.exports